import React from "react";
import TakeOffDatasourceCard, { type TakeOffCardModel } from "../shared/TakeOffDatasourceCard";
import { useTogal } from "./TogalContext";
import { getTogalProjectUrl } from "../../../../integrations/qto/sources/togal/api";
import { openExternalUrl } from "../../../../utils/links";

const useTogalCardModel = (): TakeOffCardModel => {
  const {
    togalProject,
    togalSet,
    togalAggregatedQtos,
    togalClassifications,
    togalLastUpdated,
    togalUserProfile,
    refreshClassifications,
    disconnectTogalToSelector,
  } = useTogal();

  const organizationId = togalUserProfile?.organization_id;

  return {
    present: !!togalProject,
    title: togalProject?.name ?? "",
    secondary: togalSet?.name,
    aggregatedQtos: togalAggregatedQtos,
    takeoffItemCount: togalClassifications?.length ?? null,
    lastUpdated: togalLastUpdated,
    emptyTooltip: "This project has no QTOs to review",
    onLaunch:
      togalProject && organizationId
        ? () => openExternalUrl(getTogalProjectUrl(organizationId, togalProject.id))
        : undefined,
    onRefresh: () => void refreshClassifications(),
    onDisconnect: disconnectTogalToSelector,
  };
};

const TogalDatasourceCard = ({ onCardClick }: { onCardClick: () => void }) => {
  const model = useTogalCardModel();
  return <TakeOffDatasourceCard sourceId="togal" model={model} onCardClick={onCardClick} />;
};

export default TogalDatasourceCard;
